export default class S3PhotoModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.signed_url = data.signed_url || '';
    this.s3_key = data.s3_key || '';
    this.s3_bucket = data.s3_bucket || '';
  }


  get url() {
    return this.signed_url;
  }
}
